import React, { useState } from 'react';
import { motion } from "motion/react"
import { Link } from "react-router-dom";

const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
        const yOffset = 0; // Adjust this to match your sticky header height
        const y = element.getBoundingClientRect().top + window.scrollY + yOffset;

        window.scrollTo({ top: y, behavior: "smooth" });
    }
};

export default function Header() {
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const toggleMenu = () => {
        setIsMenuOpen((prev) => !prev); // Toggle state
    };

    return (
        <>
            <div
                className="relative flex flex-row sticky w-full h-[10rem] bg-white top-0 z-40 items-center 2xl:justify-center"
            >
                {/* Hamburger Menu for Mobile */}
                <Link to="/" className="flex justify-center w-1/2 2xl:hidden group">
                    {/* Logo */}
                    <motion.div 
                        className="relative w-full h-full flex items-center justify-center font-bold"
                        onClick={() => scrollToSection("project")}
                    >
                        <img
                            src="/pictures/main_logo.webp"
                            alt="Takamori Robot Logo"
                            className="z-10 h-12 w-auto mx-auto brightness-200 group-hover:brightness-[0.9] transition duration-300"
                        />
                    </motion.div>   
                </Link>

                {/* Hamburger Menu for Mobile */}
                <div className="group flex justify-center w-1/2 2xl:hidden">
                    {/* Hamburger Button */}
                    <button
                        className="group h-20 w-20 text-black text-3xl focus:outline-none"
                        onClick={toggleMenu}
                    >
                        <div className="grid justify-items-center gap-1.5">
                            <span
                                className={`h-1 w-8 bg-black rounded-full transition-transform duration-300 ${
                                    isMenuOpen ? "rotate-45 translate-y-2.5" : ""
                                }`}
                            ></span>
                            <span
                                className={`h-1 w-8 bg-black rounded-full transition-all duration-300 ${
                                    isMenuOpen ? "scale-0" : ""
                                }`}
                            ></span>
                            <span
                                className={`h-1 w-8 bg-black rounded-full transition-transform duration-300 ${
                                    isMenuOpen ? "-rotate-45 -translate-y-2.5" : ""
                                }`}
                            ></span>
                        </div>
                    </button>
                </div>


                {/* Robot Kits, About, Logo, Educator, Login, Cart */} 
                <div className="hidden 2xl:flex flex-col w-full h-full text-white justify-center items-center">
                    <div className="flex justify-center items-center h-full w-full">
                        {/* Logo */}
                        <Link
                            to="/"
                            className="w-[15%] h-full flex items-center justify-center relative group"
                        >
                            <motion.div 
                                className="w-full h-full flex items-center justify-center relative overflow-hidden"
                                onClick={() => scrollToSection("project")}
                            >
                                <img
                                    src="/pictures/main_logo.webp"
                                    alt="Takamori Robot Logo"
                                    className="z-12 h-14 w-auto mx-auto brightness-200 group-hover:brightness-[0.9] transition duration-300"
                                />
                            </motion.div>   
                        </Link>
                    </div>

                    <div className="flex w-2/3 h-full text-white justify-center items-center gap-x-[4rem] font-bold">
                        {/* Robotic Kits */}
                        <Link
                            to="/robotickits"
                            className="w-[15%] h-full flex items-center justify-center relative group"
                        >
                            <motion.div 
                                className="w-full h-full flex items-center justify-center relative overflow-hidden"
                                onClick={() => scrollToSection("experience")}
                            >
                                {/* White Box */}
                                <div
                                    className="absolute w-[120%] h-[200%] bg-transparent group-hover:bg-black 
                                    group-hover:rotate-12 duration-100"
                                ></div>
                                {/* Text */}
                                <p className="z-10 text-black group-hover:text-white text-center">
                                    Robotics Kits
                                </p>
                            </motion.div>
                        </Link>

                        <div className="w-[15%] h-full flex items-center justify-center relative group z-40">
                        {/* Button area – clips tilted block */}
                            <div className="w-full h-full flex items-center justify-center relative overflow-hidden cursor-pointer bg-white">
                                <motion.div className="w-full h-full flex items-center justify-center relative">
                                    {/* Tilted black block */}
                                    <div
                                        className="absolute w-[120%] h-[200%] bg-transparent
                                                group-hover:bg-black group-hover:rotate-12 duration-150"
                                    />
                                    {/* Text (acts as link to /shop) */}
                                    <div
                                        className="relative z-10 text-black group-hover:text-white"
                                    >
                                        Education
                                    </div>
                                </motion.div>
                            </div>

                            {/* Dropdown menu */}
                            <div
                                className="absolute left-0 top-full w-full
                                        opacity-0 group-hover:opacity-100
                                        translate-y-1 group-hover:translate-y-0
                                        pointer-events-none group-hover:pointer-events-auto
                                        transition-all duration-150 ease-out
                                        z-50"
                            >
                                <div className="bg-white text-black shadow-md">
                                    <Link
                                        to="/education"
                                        target="_blank"
                                        className="block px-4 py-2 text-center hover:bg-gray-100"
                                    >
                                        Our Education
                                    </Link>
                                    <Link
                                        to="/classes"
                                        target="_blank"
                                        className="block px-4 py-2 text-center hover:bg-gray-100"
                                    >
                                        Classes
                                    </Link>
                                </div>
                            </div>
                        </div>


                        {/* Takamori Community */}
                        <div className="w-[15%] h-full flex items-center justify-center relative group z-40">
                        {/* Button area – clips tilted block */}
                            <div className="w-full h-full flex items-center justify-center relative overflow-hidden cursor-pointer bg-white">
                                <motion.div className="w-full h-full flex items-center justify-center relative">
                                    {/* Tilted black block */}
                                    <div
                                        className="absolute w-[120%] h-[200%] bg-transparent
                                                group-hover:bg-black group-hover:rotate-12 duration-150"
                                    />
                                    {/* Text (acts as link to /shop) */}
                                    <div
                                        className="relative z-10 text-black group-hover:text-white"
                                    >
                                        Takamori Community
                                    </div>
                                </motion.div>
                            </div>

                            {/* Dropdown menu */}
                            <div
                                className="absolute left-0 top-full w-full
                                        opacity-0 group-hover:opacity-100
                                        translate-y-1 group-hover:translate-y-0
                                        pointer-events-none group-hover:pointer-events-auto
                                        transition-all duration-150 ease-out
                                        z-50"
                            >
                                <div className="bg-white text-black shadow-md">
                                    <Link
                                        to="/community"
                                        className="block px-4 py-2 text-center hover:bg-gray-100"
                                    >
                                        Our Community
                                    </Link>
                                    <Link
                                        to="/gallery"
                                        className="block px-4 py-2 text-center hover:bg-gray-100"
                                    >
                                        Takamori Gallery
                                    </Link>
                                </div>
                            </div>
                        </div>


                        {/* About */}
                        <Link
                            to="/about"
                            className="w-[15%] h-full flex items-center justify-center relative group"
                        >
                            <motion.div 
                                className="w-full h-full flex items-center justify-center relative overflow-hidden"
                            >
                                {/* <Link to="/about"> */}
                                    {/* White Box */}
                                    <div
                                        className="absolute w-[120%] h-[200%] bg-transparent group-hover:bg-black 
                                        group-hover:rotate-12 duration-100"
                                    ></div>
                                    {/* Text */}
                                    <p className="z-10 text-black group-hover:text-white">
                                        About
                                    </p>
                            </motion.div>
                        </Link>


                        {/* Shop */}
                        <div className="w-[15%] h-full flex items-center justify-center relative group z-40">
                        {/* Button area – clips tilted block */}
                            <div className="w-full h-full flex items-center justify-center relative overflow-hidden cursor-pointer bg-white">
                                <motion.div className="w-full h-full flex items-center justify-center relative">
                                    {/* Tilted black block */}
                                    <div
                                        className="absolute w-[120%] h-[200%] bg-transparent
                                                group-hover:bg-black group-hover:rotate-12 duration-150"
                                    />
                                    {/* Text (acts as link to /shop) */}
                                    <div
                                        className="relative z-10 text-black group-hover:text-white"
                                    >
                                        Shop
                                    </div>
                                </motion.div>
                            </div>

                            {/* Dropdown menu */}
                            <div
                                className="absolute left-0 top-full w-full
                                        opacity-0 group-hover:opacity-100
                                        translate-y-1 group-hover:translate-y-0
                                        pointer-events-none group-hover:pointer-events-auto
                                        transition-all duration-150 ease-out
                                        z-50"
                            >
                                <div className="bg-white text-black shadow-md">
                                    <Link
                                        to="https://shop.takamorirobot.com/"
                                        target="_blank"
                                        className="block px-4 py-2 text-center hover:bg-gray-100"
                                    >
                                        Merch
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Mobile Dropdown Menu */}
                {isMenuOpen && (
                <div className="absolute top-36 right-0 w-full bg-black text-white flex flex-col items-center gap-y-4 py-4 z-50 2xl:hidden overflow-hidden">
                    <Link to="/robotickits" className="flex justify-center w-full hover:bg-white hover:text-black">
                        <motion.span 
                            whileTap={{ scale: 0.9 }}
                            onClick={() => scrollToSection("experience")}
                        >
                            ROBOTICS KITS
                        </motion.span>
                    </Link>


                    {/* Education + hover dropdown */}
                    <div className="w-full group flex flex-col items-center">
                        {/* main SHOP row (same width as others) */}
                        <div className="flex justify-center w-full cursor-pointer">
                            <motion.span whileTap={{ scale: 0.9 }} onClick={() => scrollToSection("ourProduct")}>
                                EDUCATION
                            </motion.span>
                        </div>

                        {/* dropdown block: same width as button, white bg, black text */}
                        <div
                            className="
                            w-full bg-white text-black
                            max-h-0 overflow-hidden
                            group-hover:max-h-40
                            transition-all duration-400
                            font-semibold
                            "
                        >
                            <Link
                                to="/education"
                                className="block w-full text-center px-4 py-2 text-sm hover:bg-gray-100"
                            >
                                Our Education
                            </Link>
                            <Link
                                to="/classes"
                                className="block w-full text-center px-4 py-2 text-sm hover:bg-gray-100"
                            >
                                Classes
                            </Link>
                        </div>
                    </div>


                    {/* Community + hover dropdown */}
                    <div className="w-full group flex flex-col items-center">
                        {/* main SHOP row (same width as others) */}
                        <div className="flex justify-center w-full cursor-pointer">
                            <motion.span whileTap={{ scale: 0.9 }} onClick={() => scrollToSection("ourProduct")}>
                                COMMUNITY
                            </motion.span>
                        </div>

                        {/* dropdown block: same width as button, white bg, black text */}
                        <div
                            className="
                            w-full bg-white text-black
                            max-h-0 overflow-hidden
                            group-hover:max-h-40
                            transition-all duration-400
                            font-semibold
                            "
                        >
                            <Link
                                to="/community"
                                className="block w-full text-center px-4 py-2 text-sm hover:bg-gray-100"
                            >
                                Our Community
                            </Link>
                            <Link
                                to="/gallery"
                                className="block w-full text-center px-4 py-2 text-sm hover:bg-gray-100"
                            >
                                Takamori Gallery
                            </Link>
                        </div>
                    </div>


                    <Link to="/about" className="flex justify-center w-full hover:bg-white hover:text-black">
                        <motion.span 
                            whileTap={{ scale: 0.9 }}
                            onClick={() => scrollToSection("ourProduct")}
                        >
                            ABOUT
                        </motion.span>
                    </Link>


                    {/* SHOP + hover dropdown */}
                    <div className="w-full group flex flex-col items-center">
                        {/* main SHOP row (same width as others) */}
                        <div className="flex justify-center w-full cursor-pointer">
                            <motion.span whileTap={{ scale: 0.9 }} onClick={() => scrollToSection("ourProduct")}>
                            SHOP
                            </motion.span>
                        </div>

                        {/* dropdown block: same width as button, white bg, black text */}
                        <div
                            className="
                            w-full bg-white text-black
                            max-h-0 overflow-hidden
                            group-hover:max-h-40
                            transition-all duration-400
                            font-semibold
                            "
                        >
                            <Link
                                to="https://shop.takamorirobot.com/"
                                target="_blank"
                                className="block w-full text-center px-4 py-2 text-sm hover:bg-gray-100"
                            >
                                MERCH
                            </Link>
                        </div>
                    </div>
                </div>
                )}   
            </div>   
        </>
    )
}